import React, { useState } from 'react';
import { TruckIcon, PackageIcon, PlusCircleIcon, CheckIcon, XIcon, FactoryIcon, UserIcon, BoxIcon, ScaleIcon, GaugeIcon } from 'lucide-react';
interface Shipment {
  id: string;
  type: string;
  amount: number;
  source: string;
  customer: string;
  containers: number;
  containerWeight: number;
  bemerkung: string;
}
export function ShippingInfo() {
  const [shipments, setShipments] = useState<Shipment[]>([{
    id: '1',
    type: 'Tankzug',
    amount: 27.22,
    source: 'Tank 1',
    customer: 'MM',
    containers: 18,
    containerWeight: 23400,
    bemerkung: ''
  }]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingBemerkung, setEditingBemerkung] = useState<string | null>(null);
  const [tempBemerkung, setTempBemerkung] = useState('');
  const [newShipment, setNewShipment] = useState<Shipment>({
    id: '',
    type: 'Tankzug',
    amount: 0,
    source: '',
    customer: '',
    containers: 0,
    containerWeight: 0,
    bemerkung: ''
  });
  const tanks = ['Tank 1', 'Tank 2', 'Tank 3', 'Tank 4', 'Tank 5'];
  const handleSaveBemerkung = (shipmentId: string) => {
    setShipments(shipments.map(shipment => shipment.id === shipmentId ? {
      ...shipment,
      bemerkung: tempBemerkung
    } : shipment));
    setEditingBemerkung(null);
    setTempBemerkung('');
  };
  const handleAddShipment = () => {
    const id = (shipments.length + 1).toString();
    setShipments([...shipments, {
      ...newShipment,
      id
    }]);
    setNewShipment({
      id: '',
      type: 'Tankzug',
      amount: 0,
      source: '',
      customer: '',
      containers: 0,
      containerWeight: 0,
      bemerkung: ''
    });
    setIsModalOpen(false);
  };
  const ShipmentCard = ({
    shipment
  }: {
    shipment: Shipment;
  }) => <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-1018">
      <div className="flex items-center justify-between mb-4" data-id="element-1019">
        <div className="flex items-center gap-2" data-id="element-1020">
          {shipment.type === 'Tankzug' ? <TruckIcon size={16} className="text-[#3498dd]" data-id="element-1021" /> : <PackageIcon size={16} className="text-[#3498dd]" data-id="element-1022" />}
          <h4 className="font-medium text-gray-800" data-id="element-1023">{shipment.type}</h4>
        </div>
        <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs" data-id="element-1024">
          {shipment.customer}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1025">
        <div className="p-2 bg-gray-50 rounded border border-gray-200" data-id="element-1026">
          <div className="flex items-center text-xs text-gray-500 mb-1" data-id="element-1027">
            <ScaleIcon size={12} className="mr-1" data-id="element-1028" />
            Menge
          </div>
          <div className="font-medium" data-id="element-1029">{shipment.amount}t</div>
        </div>
        <div className="p-2 bg-gray-50 rounded border border-gray-200" data-id="element-1030">
          <div className="flex items-center text-xs text-gray-500 mb-1" data-id="element-1031">
            <FactoryIcon size={12} className="mr-1" data-id="element-1032" />
            Quelle
          </div>
          <div className="font-medium" data-id="element-1033">{shipment.source}</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1034">
        <div className="p-2 bg-gray-50 rounded border border-gray-200" data-id="element-1035">
          <div className="flex items-center text-xs text-gray-500 mb-1" data-id="element-1036">
            <BoxIcon size={12} className="mr-1" data-id="element-1037" />
            Container
          </div>
          <div className="font-medium" data-id="element-1038">{shipment.containers} Stk.</div>
        </div>
        <div className="p-2 bg-gray-50 rounded border border-gray-200" data-id="element-1039">
          <div className="flex items-center text-xs text-gray-500 mb-1" data-id="element-1040">
            <ScaleIcon size={12} className="mr-1" data-id="element-1041" />
            Gewicht
          </div>
          <div className="font-medium" data-id="element-1042">{shipment.containerWeight}kg</div>
        </div>
      </div>
      <div className="pt-2 border-t border-gray-200" data-id="element-1043">
        {editingBemerkung === shipment.id ? <div className="flex gap-2" data-id="element-1044">
            <input type="text" value={tempBemerkung} onChange={e => setTempBemerkung(e.target.value)} placeholder="Bemerkung eingeben..." className="flex-1 px-3 py-1.5 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500" onKeyDown={e => {
          if (e.key === 'Enter') handleSaveBemerkung(shipment.id);
        }} data-id="element-1045" />
            <button onClick={() => handleSaveBemerkung(shipment.id)} className="px-2 py-1.5 text-gray-400 hover:text-gray-600" data-id="element-1046">
              <CheckIcon size={14} data-id="element-1047" />
            </button>
          </div> : shipment.bemerkung ? <div className="flex items-center justify-between group" data-id="element-1048">
            <span className="text-sm text-gray-600" data-id="element-1049">{shipment.bemerkung}</span>
            <button onClick={() => {
          setEditingBemerkung(shipment.id);
          setTempBemerkung(shipment.bemerkung);
        }} className="opacity-0 group-hover:opacity-100 transition-opacity px-2 py-1 text-gray-400 hover:text-gray-600" data-id="element-1050">
              <PlusCircleIcon size={14} data-id="element-1051" />
            </button>
          </div> : <button onClick={() => {
        setEditingBemerkung(shipment.id);
        setTempBemerkung('');
      }} className="w-full py-2 px-3 border border-dashed border-gray-300 rounded-md text-sm text-gray-500 hover:border-gray-400 hover:text-gray-600 transition-colors flex items-center justify-center gap-2" data-id="element-1052">
            <PlusCircleIcon size={14} data-id="element-1053" />
            Bemerkung hinzufügen
          </button>}
      </div>
    </div>;
  return <div className="bg-gray-50 rounded-lg p-6" data-id="element-1054">
      <div className="flex items-center justify-between mb-6" data-id="element-1055">
        <div className="flex items-center gap-2" data-id="element-1056">
          <TruckIcon className="text-[#3498dd]" size={20} data-id="element-1057" />
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-1058">Verladung</h3>
        </div>
        <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 bg-[#3498dd] text-white px-3 py-1.5 rounded text-sm hover:bg-blue-600" data-id="element-1059">
          <PlusCircleIcon size={16} data-id="element-1060" />
          Neue Verladung
        </button>
      </div>
      <div className="mb-6" data-id="element-1061">
        <div className="grid grid-cols-4 gap-4" data-id="element-1062">
          <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1063">
            <div className="flex items-center justify-between" data-id="element-1064">
              <div className="flex items-center gap-2" data-id="element-1065">
                <div className="p-2 bg-blue-50 rounded" data-id="element-1066">
                  <TruckIcon className="text-[#3498dd]" size={24} data-id="element-1067" />
                </div>
                <div data-id="element-1068">
                  <h4 className="text-sm font-medium text-gray-700" data-id="element-1069">
                    Verladungen
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-1070">Anzahl</p>
                </div>
              </div>
              <div className="text-2xl font-bold text-gray-800" data-id="element-1071">
                {shipments.length}{' '}
                <span className="text-sm font-normal text-gray-500" data-id="element-1072">Stk</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1073">
            <div className="flex items-center justify-between" data-id="element-1074">
              <div className="flex items-center gap-2" data-id="element-1075">
                <div className="p-2 bg-blue-50 rounded" data-id="element-1076">
                  <ScaleIcon className="text-[#3498dd]" size={24} data-id="element-1077" />
                </div>
                <div data-id="element-1078">
                  <h4 className="text-sm font-medium text-gray-700" data-id="element-1079">
                    Gesamtmenge
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-1080">Verladen</p>
                </div>
              </div>
              <div className="text-2xl font-bold text-gray-800" data-id="element-1081">
                {shipments.reduce((acc, s) => acc + s.amount, 0).toFixed(1)}{' '}
                <span className="text-sm font-normal text-gray-500" data-id="element-1082">t</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1083">
            <div className="flex items-center justify-between" data-id="element-1084">
              <div className="flex items-center gap-2" data-id="element-1085">
                <div className="p-2 bg-blue-50 rounded" data-id="element-1086">
                  <GaugeIcon className="text-[#3498dd]" size={24} data-id="element-1087" />
                </div>
                <div data-id="element-1088">
                  <h4 className="text-sm font-medium text-gray-700" data-id="element-1089">
                    Platzhalter 1
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-1090">Beschreibung</p>
                </div>
              </div>
              <div className="text-2xl font-bold text-gray-800" data-id="element-1091">
                0 <span className="text-sm font-normal text-gray-500" data-id="element-1092">-</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1093">
            <div className="flex items-center justify-between" data-id="element-1094">
              <div className="flex items-center gap-2" data-id="element-1095">
                <div className="p-2 bg-blue-50 rounded" data-id="element-1096">
                  <GaugeIcon className="text-[#3498dd]" size={24} data-id="element-1097" />
                </div>
                <div data-id="element-1098">
                  <h4 className="text-sm font-medium text-gray-700" data-id="element-1099">
                    Platzhalter 2
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-1100">Beschreibung</p>
                </div>
              </div>
              <div className="text-2xl font-bold text-gray-800" data-id="element-1101">
                0 <span className="text-sm font-normal text-gray-500" data-id="element-1102">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1103">
        {shipments.map(shipment => <ShipmentCard key={shipment.id} shipment={shipment} data-id="element-1104" />)}
      </div>
      {isModalOpen && <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-1105">
          <div className="bg-white rounded-lg p-6 w-[600px] max-w-full m-4" data-id="element-1106">
            <div className="flex justify-between items-center mb-6" data-id="element-1107">
              <h4 className="text-lg font-semibold text-gray-800" data-id="element-1108">
                Neue Verladung
              </h4>
              <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600" data-id="element-1109">
                <XIcon size={20} data-id="element-1110" />
              </button>
            </div>
            <div className="space-y-6" data-id="element-1111">
              <div className="grid grid-cols-2 gap-4" data-id="element-1112">
                <div data-id="element-1113">
                  <label className="block text-sm text-gray-700 mb-1" data-id="element-1114">
                    Typ
                  </label>
                  <select value={newShipment.type} onChange={e => setNewShipment({
                ...newShipment,
                type: e.target.value
              })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1115">
                    <option value="Tankzug" data-id="element-1116">Tankzug</option>
                    <option value="Container" data-id="element-1117">Container</option>
                  </select>
                </div>
                <div data-id="element-1118">
                  <label className="block text-sm text-gray-700 mb-1" data-id="element-1119">
                    Quelle
                  </label>
                  <select value={newShipment.source} onChange={e => setNewShipment({
                ...newShipment,
                source: e.target.value
              })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1120">
                    <option value="" data-id="element-1121">Bitte wählen...</option>
                    {tanks.map(tank => <option key={tank} value={tank} data-id="element-1122">
                        {tank}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-1123">
                  <label className="block text-sm text-gray-700 mb-1" data-id="element-1124">
                    Menge (t)
                  </label>
                  <input type="number" value={newShipment.amount} onChange={e => setNewShipment({
                ...newShipment,
                amount: parseFloat(e.target.value)
              })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1125" />
                </div>
                <div data-id="element-1126">
                  <label className="block text-sm text-gray-700 mb-1" data-id="element-1127">
                    Kunde
                  </label>
                  <input type="text" value={newShipment.customer} onChange={e => setNewShipment({
                ...newShipment,
                customer: e.target.value
              })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1128" />
                </div>
                <div data-id="element-1129">
                  <label className="block text-sm text-gray-700 mb-1" data-id="element-1130">
                    Container (Stk.)
                  </label>
                  <input type="number" value={newShipment.containers} onChange={e => setNewShipment({
                ...newShipment,
                containers: parseInt(e.target.value)
              })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1131" />
                </div>
                <div data-id="element-1132">
                  <label className="block text-sm text-gray-700 mb-1" data-id="element-1133">
                    Gewicht (kg)
                  </label>
                  <input type="number" value={newShipment.containerWeight} onChange={e => setNewShipment({
                ...newShipment,
                containerWeight: parseInt(e.target.value)
              })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1134" />
                </div>
              </div>
              <div data-id="element-1135">
                <label className="block text-sm text-gray-700 mb-1" data-id="element-1136">
                  Bemerkung
                </label>
                <input type="text" value={newShipment.bemerkung} onChange={e => setNewShipment({
              ...newShipment,
              bemerkung: e.target.value
            })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1137" />
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6" data-id="element-1138">
              <button onClick={() => setIsModalOpen(false)} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded" data-id="element-1139">
                Abbrechen
              </button>
              <button onClick={handleAddShipment} className="px-4 py-2 text-sm text-white bg-[#3498dd] hover:bg-blue-600 rounded" data-id="element-1140">
                Speichern
              </button>
            </div>
          </div>
        </div>}
    </div>;
}